// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './permission';
// import 'normalize.css'
// import 'vue2-animate/dist/vue2-animate.min.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/dist/css/swiper.css'
// import CircleMenu from 'vue-circle-menu'
// import '@/mock' // permission control
import yxLog from './utils/yxLog'

import $ from 'jquery'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import { set } from 'shelljs'
import ECharts from 'vue-echarts/components/ECharts.vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
// Vue.use(CircleMenu)
Vue.use(ElementUI)
Vue.use(Viewer)
Vue.component('v-chart', ECharts);

if (process.env.NODE_ENV === 'production') {
  window.$Raven = Raven;
  Raven
    .config('https://a72af67c388b4beba2c7bb6a7db138c3@sentry.classba.cn/41', {
      environment: 'prod'
    })
    .addPlugin(RavenVue, Vue)
    .install();
  Vue.config.errorHandler = function(err, vm, info) {
    Raven.captureException(err);
  }
}

Vue.config.productionTip = false

window.ugee_version = -1
// 原来的手写板
let tabletExtensionId = 'bjkkhgeamncppjfbhbchodmilogldmkp'
window.testOn = () => {}
window.port = ''

// 新的汉王手写板
let hwTabletExtensionId = 'mijdieedncplebckofhbflklaciekibp' 
window.hwTestOn = () => {}
window.hwPort = ''


// 优先使用汉王的手写板
try {
  window.hwPort = chrome.runtime.connect(hwTabletExtensionId) // 线上环境
  window.hwTestOn = (callBack) => {
    window.hwPort.onMessage.addListener((msg) => {
      callBack(msg)
    })
  }
  chrome.runtime.sendMessage(hwTabletExtensionId, { message: "ugee_version" }, (reply) => {
    console.log('reply='+JSON.stringify(reply))
    if (reply && reply.ugee_version) {
      window.ugee_version = 2
    } else {
      oldConnect()
    }
  });
  
} catch (e) {
  window.hwPort = '';
}

function oldConnect() {
  try {
    window.port = chrome.runtime.connect(tabletExtensionId) // 线上环境
    window.testOn = (callBack) => {
      window.port.onMessage.addListener((msg) => {
        callBack(msg)
      })
    }
    chrome.runtime.sendMessage(tabletExtensionId, { message: {'cmd': 'dongleStatus'} }, (reply) => {
      window.ugee_version = 1
      console.log('ugee_version'+window.ugee_version)
    });
  } catch (e) {
    window.port = ''
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js